import axios from 'axios';
import { API_URL } from '../../lib/api';

const o = { withCredentials: true };
export const R = `${API_URL}/api/invoice-review`;
export const S = `${API_URL}/api/scan/results`;
export const fileUrl = (docId) => `${API_URL}/api/scan/documents/${docId}/file`;
export const thumbUrl = (docId) => `${R}/documents/${docId}/miniature`;
export const eur = (n) => (n === null || n === undefined || n === '') ? '—' : `${Number(n).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const frDate = (d) => d ? new Date(d.length === 10 ? `${d}T12:00:00` : d).toLocaleDateString('fr-FR') : '—';
export const errMsg = (e) => e?.response?.data?.detail || 'Erreur';

// Secrétariat sans permission de valider : les actions financières deviennent des préparations
export const PREP = { on: false };
const prepare = (id, cible, body, resume) => axios.post(`${R}/factures/${id}/preparation`, { cible, body, resume }, o).then(r => r.data);

export const api = {
    list: (params) => axios.get(`${R}/factures`, { ...o, params }).then(r => r.data),
    detail: (id) => axios.get(`${R}/factures/${id}`, o).then(r => r.data),
    searchVehicles: (q, rid) => axios.get(`${R}/vehicules`, { ...o, params: { q, rid } }).then(r => r.data),
    vehicle: (id, rid) => axios.get(`${R}/vehicules/${id}`, { ...o, params: { rid } }).then(r => r.data),
    keepPlate: (id, plate) => axios.put(`${S}/${id}`, { immatriculation_detectee: plate }, o).then(r => r.data),
    save: (id, body) => axios.put(`${S}/${id}`, body, o).then(r => r.data),
    prepare,
    rejectPreparation: (id) => axios.delete(`${R}/factures/${id}/preparation`, o).then(r => r.data),
    validate: (id, body) => (PREP.on ? prepare(id, 'validate', body, 'Frais véhicule : nouvelle dépense') : axios.post(`${S}/${id}/validate`, body, o).then(r => r.data)),
    forceAttach: (id) => axios.post(`${S}/${id}/force-attach`, {}, o).then(r => r.data),
    linkExisting: (id, body) => (PREP.on ? prepare(id, 'link-existing', body, `Frais véhicule : justificatif du frais « ${body.expected_nom} »`) : axios.post(`${S}/${id}/link-existing`, body, o).then(r => r.data)),
    attachDocument: (id, body) => (PREP.on ? prepare(id, 'attach-document', body, 'Document seul, sans dépense') : axios.post(`${S}/${id}/attach-document`, body, o).then(r => r.data)),
    splitSave: (id, body) => axios.put(`${R}/factures/${id}/repartition`, body, o).then(r => r.data),
    dismiss: (ids, motif, commentaire) => axios.post(`${R}/factures/ecarter`, { ids, motif, commentaire }, o).then(r => r.data),
    restoreMany: (ids) => axios.post(`${R}/factures/restaurer`, { ids }, o).then(r => r.data),
    deleteForever: (id) => axios.delete(`${R}/factures/${id}/definitif`, o).then(r => r.data),
    splitDrop: (id) => axios.delete(`${R}/factures/${id}/repartition`, o).then(r => r.data),
    splitValidate: (id, body) => axios.post(`${R}/factures/${id}/repartition/valider`, body, o).then(r => r.data),
    note: (id, note) => axios.post(`${R}/factures/${id}/note`, { note }, o).then(r => r.data),
    restore: (id) => axios.post(`${R}/factures/${id}/remettre-en-attente`, {}, o).then(r => r.data),
    filesStatus: () => axios.get(`${R}/fichiers/verification`, o).then(r => r.data),
    filesStart: () => axios.post(`${R}/fichiers/verifier`, {}, o).then(r => r.data),
    erasePending: () => axios.get(`${R}/fichiers/a-nettoyer`, o).then(r => r.data),
    eraseRetry: () => axios.post(`${R}/fichiers/nettoyer`, {}, o).then(r => r.data),
    options: (id) => axios.get(`${R}/factures/${id}/options`, o).then(r => r.data),
    assign: (id, body) => axios.post(`${R}/factures/${id}/affecter`, body, o).then(r => r.data),
    savSimulation: (id, body) => axios.post(`${R}/factures/${id}/sav/simulation`, body, o).then(r => r.data),
    vehicleSav: (vid, rid) => axios.get(`${R}/vehicules/${vid}/sav`, { ...o, params: { rid } }).then(r => r.data),
    history: (id) => axios.get(`${R}/factures/${id}/historique`, o).then(r => r.data),
    lines: (id) => axios.get(`${R}/factures/${id}/lignes`, o).then(r => r.data),
    setNature: (ids, nature) => axios.put(`${R}/lignes/nature`, { ids, nature }, o).then(r => r.data),
    attribute: (ids, vehicleId) => axios.put(`${R}/lignes/attribution`, { ids, vehicle_id: vehicleId || null }, o).then(r => r.data),
    merge: (ids) => axios.post(`${R}/lignes/regrouper`, { ids }, o).then(r => r.data),
    unmerge: (id) => axios.post(`${R}/lignes/separer`, { id }, o).then(r => r.data),
    correction: (id, body) => axios.post(`${R}/factures/${id}/correction`, body, o).then(r => r.data),
    replaceExisting: (id, body) => axios.post(`${S}/${id}/replace-existing`, body, o).then(r => r.data),
    keepAsProof: (id, ref) => axios.post(`${R}/factures/${id}/justificatif-doublon`, { ref }, o).then(r => r.data),
};

// Doublon confirmé (409) : conserver comme justificatif sans coût, ou forcer (administrateur)
export async function resolveConfirmedDuplicate(id, e, confirm, retry) {
    const [msg, ref] = errMsg(e).split('|');
    if (ref && await confirm(`${msg}\n\nConserver cette facture comme justificatif de la dépense existante ? Aucun nouveau coût ne sera créé.`, { title: 'Doublon confirmé', confirmLabel: 'Conserver comme justificatif' })) {
        return api.keepAsProof(id, ref);
    }
    if (!(await confirm(`${msg}\n\nForcer quand même une nouvelle dépense (administrateur uniquement) ?`, { title: 'Forcer le doublon', confirmLabel: 'Forcer', danger: true }))) return false;
    return retry();
}

export const STATUT = {
    en_attente: ['En attente', 'bg-amber-50 text-amber-700 border-amber-200'],
    a_verifier: ['À vérifier', 'bg-amber-50 text-amber-700 border-amber-200'],
    doublon_detecte: ['Doublon possible', 'bg-red-50 text-red-700 border-red-200'],
    deja_scannee: ['Déjà scannée', 'bg-red-50 text-red-700 border-red-200'],
    valide: ['Dépense créée', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
    lie_existant: ['Justificatif d\'un frais', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
    justificatif_seul: ['Justificatif seul', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
    reparti_en_cours: ['Répartition en cours', 'bg-indigo-50 text-indigo-700 border-indigo-200'],
    reparti: ['Répartie', 'bg-indigo-50 text-indigo-700 border-indigo-200'],
    supprime: ['Écartée', 'bg-gray-100 text-gray-500 border-gray-200'],
    archive: ['Archivée', 'bg-gray-100 text-gray-500 border-gray-200'],
    doublon_agence: ['Doublon charge', 'bg-gray-100 text-gray-500 border-gray-200'],
    doublon_retenue: ['Doublon retenue', 'bg-gray-100 text-gray-500 border-gray-200'],
    regroupee: ['Regroupée', 'bg-gray-100 text-gray-500 border-gray-200'],
    justificatif_doublon: ['Justificatif (doublon)', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
};

export const AFFECTATION = { repartition: 'Répartie sur plusieurs véhicules', frais_agence: "Frais d'agence", frais_mutualise: 'Frais mutualisé', retenue_commercial: 'Retenue commercial', sav: 'SAV' };

export const StatutBadge = ({ s, a, testId }) => {
    const [l0, c] = STATUT[s] || [s, 'bg-gray-100 text-gray-600 border-gray-200'];
    const l = s === 'valide' && AFFECTATION[a] ? AFFECTATION[a] : l0;
    return <span className={`inline-flex px-1.5 py-0.5 rounded-full border text-[10px] font-medium whitespace-nowrap ${c}`} data-testid={testId}>{l}</span>;
};
